import { finishedUpgradePrice } from './blissUpgradePricing.js'

export type BasicGuardrailStyle = 'horizontal' | 'horizontal_3bar' | 'x_pattern' | 'x_pattern_front'

export const X_GUARDRAIL_MATERIALS_COST_PER_BUNK = 200

/** Two horizontal variants and the approved X-pattern wood design. */
export const BASIC_GUARDRAIL_STYLES: ReadonlyArray<{
  id: BasicGuardrailStyle
  label: string
  description: string
  pricePerBunk: number | null
}> = [
  {
    id: 'horizontal',
    label: '2-bar horizontal wood',
    description: 'Clean, parallel wood rails.',
    pricePerBunk: 0,
  },
  {
    id: 'horizontal_3bar',
    label: '3-bar horizontal wood',
    description: 'Taller horizontal guarding with longer supports and 3½-inch clear gaps.',
    pricePerBunk: 500, // Owner-confirmed finished price; raw materials cost is not yet supplied.
  },
  {
    id: 'x_pattern',
    label: 'X-pattern wood',
    description: 'Framed wood crosses with precise mitered cuts and angled joinery.',
    pricePerBunk: finishedUpgradePrice(X_GUARDRAIL_MATERIALS_COST_PER_BUNK),
  },
  { id: 'x_pattern_front', label: 'X-pattern front + inside return', description: 'Front X panels with an L-shaped return beside the stairwell.', pricePerBunk: null },
]

export function isXGuardrail(style?: BasicGuardrailStyle) { return style === 'x_pattern' || style === 'x_pattern_front' }

export const X_GUARDRAIL = { stock: 1.5, openingHeight: 11, height: 14 } as const

export function isBasicGuardrailStyle(value: unknown): value is BasicGuardrailStyle {
  return BASIC_GUARDRAIL_STYLES.some(style => style.id === value)
}

export function guardrailOption(style: BasicGuardrailStyle = 'horizontal') {
  return BASIC_GUARDRAIL_STYLES.find(option => option.id === style)!
}

export function horizontalGuardBars(style?: BasicGuardrailStyle): 2 | 3 {
  return style === 'horizontal_3bar' ? 3 : 2
}

export function guardrailDescription(style: BasicGuardrailStyle = 'horizontal') {
  return style === 'x_pattern_front' ? 'X-pattern front guardrails with L-shaped stairwell returns' : style === 'x_pattern'
    ? 'X-pattern wood guardrails'
    : `Horizontal wood guardrails · ${horizontalGuardBars(style)} bars`
}
